import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,setUpdateButtonActiveStepToTrue} from '../../../../store/actions/main';
import {updateDirectionTore, updateStepsTore} from '../../../../store/actions/tore';
import {InputRadio} from '../../../../module/inputRadio';

const Step_7 = (props) => {
  let [direction, selectDirection] = useState('');
  let [titel, updateTitel] = useState('');

    useEffect(() => {
      updateItems();
    })

   const updateItems = () => {
      const {direction} = props.data[props.modell_index];

      selectDirection(direction);

      //update step titel
      if (props.modell_kind === 'fluegeltor') {
          updateTitel('Wie soll das Tor geöffnet werden?');
      } else {
          updateTitel('Öffnungsrichtung von der Strasse aus gesehen:');
      }

      //update steps
      props.updateStepsTore(6);
      if(direction) props.updateStepsTore(7);

      if(direction || props.data[props.modell_index].allVisitedSteps) {
        props.setUpdateButtonActiveStepToFalse();
      } else {
        props.setUpdateButtonActiveStepToTrue();
      }

   }

   const updateDirection = ev => {
      props.updateDirectionTore(ev.target.value);
      updateItems();
   }

  const arrayRadioItemsInnen = [
    {labalValue: 'Nach Innen', labelTitel: 'Nach Innen'},
    {labalValue: 'Nach Außen', labelTitel: 'Nach Außen'}
  ]

  const arrayRadioItemsAussen = [
    {labalValue: 'Links', labelTitel: 'Links'},
    {labalValue: 'Rechts', labelTitel: 'Rechts'}
  ]

  let modell_kind = props.data[props.modell_index].modell[0].kind;

   return (
           <div className="step_wrapper">
             <h2 className="step_header">{titel}</h2>
              <div className="step_icon_wrapper">
                <div className="inner_textfield_wrapper direction">
                      <InputRadio
                          onChange={updateDirection}
                          value={direction}
                          name='Öffnungsrichtung'
                          arial_label='Öffnungsrichtung'
                          arrayRadioItems={modell_kind === 'Flügeltor'?arrayRadioItemsInnen:arrayRadioItemsAussen}
                      />
                  </div>
              </div>
          </div>
   )
}

const mapStateToProps = state => {
    return {
      data: state.toreReducer.data,
      modell_index: state.toreReducer.modell_index
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      updateDirectionTore: ev => dispatch(updateDirectionTore(ev)),
      updateStepsTore: ev => dispatch(updateStepsTore(ev))
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_7);
